import { Button, TextInput } from "@prosolve/common-components-ui";
import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import styled from "styled-components";

const FormFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const FormFieldLabel = styled.div`
  color: #565656;
  font-weight: bold; 
  font-size: 14px;
  margin-bottom: 5px;
`

const resToArray = (r) => r?.trim().length === 0 ? [] : r?.split(',').map(r => r?.split('||')) || []
const resFromArray = (arr) => arr?.map(r => r?.join('||')).join(',').trim() || ''

export { resToArray, resFromArray }

export default ({
  resources: defaultResources,
  onUpdate
}) => {
  const [resources, setResources] = useState(defaultResources || '')

  const resourcesArr = resToArray(resources)

  const onChangeResource = (index, name, url) => {
    resourcesArr[index][0] = name?.replace(/[,|]/gi, '') ?? resourcesArr[index][0]
    resourcesArr[index][1] = url?.replace(/[,|]/gi, '') ?? resourcesArr[index][1]
    const newResources = resFromArray(resourcesArr)
    setResources(newResources)
  }

  const onAddResource = () => {
    const newResourcesArr = [...resourcesArr, ['','']]
    setResources(resFromArray(newResourcesArr))
  }

  const onDeleteResource = (index) => {
    const newResourcesArr = [...resourcesArr]
    newResourcesArr.splice(index, 1)
    const newResources = resFromArray(newResourcesArr)
    setResources(newResources)
  }
  
  useEffect(() => {
    onUpdate(resources)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resources])

  return (
    <div>
      <FormFieldLabel style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: '10px',
        fontSize: '16px',
      }}>
        <span style={{ fontSize: '24px '}}>{'Resources'}</span>
        <Button onClick={onAddResource} style={{
          display: 'flex',
          gap: '5px',
          padding: '8px 16px',
          color: 'rgb(86, 86, 86)',
        }}>
          <FaPlus style={{ color: 'rgb(2, 128, 198)' }} />
          <span>Add Resource</span>
        </Button>
      </FormFieldLabel>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        background: '#fdfdfd',
        border: '1px solid #dedede',
        borderRadius: '5px',
        padding: '13px'
      }}>
        {resourcesArr.length === 0
        ?
        <div>
          No resources have been added
        </div>
        :
        resourcesArr.map((resource, index) =>
          <div 
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <FormFieldWrapper style={{ flex: 1 }}>
              <FormFieldLabel>Name:</FormFieldLabel>
              <TextInput
                value={resource?.[0]}
                onChange={(val) => onChangeResource(index, val, undefined)}
                placeholder='Ex: Venue'
              />
            </FormFieldWrapper>

            <FormFieldWrapper style={{ flex: 2 }}>
              <FormFieldLabel>URL:</FormFieldLabel>
              <TextInput
                value={resource?.[1]}
                onChange={(val) => onChangeResource(index, undefined, val)}
                placeholder='Ex: https://our-venue-website.com'
              />
            </FormFieldWrapper>

            <div style={{ color: 'red', cursor: 'pointer', margin: '22px 0 0 0' }}>
              <FaTrash onClick={() => onDeleteResource(index)} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}